import { isImpliedPartRelation } from '../utils/bomContributions';

/**
 * Resolve implied-part flag for a single BOM line (PartsToAssembly / PartsToSubAssembly).
 * Never infer implied status from other BOM lines that share the same partFk.
 */
export function isBomLineImpliedPart(bomLine, bomChanges = null, lineId = null) {
    const id = lineId ?? bomLine?.id;
    if (bomChanges && id != null && bomChanges[id]?.isImpliedPart !== undefined) {
        return !!bomChanges[id].isImpliedPart;
    }
    return isImpliedPartRelation(bomLine);
}

/** Unit cost from PartExpanded (cost / quantity). Returns null when unknown. */
export function getPartUnitCostFromExpanded(expandedPart) {
    if (!expandedPart || !expandedPart.quantity) return null;
    return expandedPart.cost / expandedPart.quantity;
}

/** Unit cost for one BOM line; implied lines are always 0. */
export function getBomLineUnitCost(bomLine, expandedPart, options = {}) {
    const { bomChanges, lineId } = options;
    if (isBomLineImpliedPart(bomLine, bomChanges, lineId)) return 0;
    const unitCost = getPartUnitCostFromExpanded(expandedPart);
    return unitCost != null ? unitCost : null;
}

/** Extended cost for one BOM line. */
export function getBomLineExtendedCost(bomLine, expandedPart, quantity, options = {}) {
    const unitCost = getBomLineUnitCost(bomLine, expandedPart, options);
    if (unitCost == null) return null;
    const qty = Number(quantity);
    if (!Number.isFinite(qty)) return 0;
    return unitCost * qty;
}

export function formatBomUnitCost(bomLine, expandedPart, options = {}) {
    const unitCost = getBomLineUnitCost(bomLine, expandedPart, options);
    if (unitCost == null) return '-';
    return unitCost.toFixed(2);
}

export function formatBomExtendedCost(bomLine, expandedPart, quantity, options = {}) {
    const extCost = getBomLineExtendedCost(bomLine, expandedPart, quantity, options);
    if (extCost == null) return '-';
    return extCost.toFixed(2);
}

export function formatBomUnitCostDisplay(bomLine, expandedPart, options = {}) {
    const formatted = formatBomUnitCost(bomLine, expandedPart, options);
    return formatted === '-' ? formatted : `$${formatted}`;
}

export function formatBomExtendedCostDisplay(bomLine, expandedPart, quantity, options = {}) {
    const formatted = formatBomExtendedCost(bomLine, expandedPart, quantity, options);
    return formatted === '-' ? formatted : `$${formatted}`;
}
